import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

class BinderConfirmation extends Component {

	componentDidMount() {
		window.scrollTo(0, 0);
		if(this.props.state.list && !this.props.state.list.availability) {
			//Redirect to list page if user directly comes on this page
			browserHistory.push("/list");
		}
	}

    render() {
        return (
            <div>
				<div className="push">
					{this.props.params.type === "save"
						?<h1>SAVE BROCHURE</h1>
						:<h1>CREATE BINDER</h1>
					}
				</div>
				{this.props.params.type === "save"
					?<div>
						<p className="importantText bold">Your brochure has been saved under the following name:</p>
						<p className="bold">{this.props.state.brochure.payload.brochure.brochureName}</p>
						<p>To access your brochure, go to <b>Saved Brochures</b> under the <b>Tools</b> menu.</p>
					</div>
					:<p className="importantText bold">Your binder created successfully.<br/><br/>You will receive email shortly with the download link.</p>
				}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return { state };
};

BinderConfirmation = connect(mapStateToProps)(BinderConfirmation);
export default BinderConfirmation;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Binders/confirmation.js